import { InjectionToken } from '@angular/core';

export const SORT_COMPARE = new InjectionToken<CompareFn>('Sort Compare');
export type CompareFn = (a: string, b: string) => number;

export const sortCompareFactory = (locale: string) =>
  new Intl.Collator(locale, {
    usage: 'sort',
    numeric: true,
    ignorePunctuation: true,
  }).compare;

export const SEARCH_EQUALITY = new InjectionToken<EqualityFn>('Search Equality');
export type EqualityFn = (a: string, b: string) => boolean;

export const searchEqualityFactory = (locale: string) => {
  const compare = new Intl.Collator(locale, {
    usage: 'search',
    sensitivity: 'base',
    numeric: true,
    ignorePunctuation: true,
  }).compare;

  return (a, b) => compare(a, b) === 0;
};
